import { User } from '../auth/interfaces/user';
import {
  getDeploymentEnv,
  getFullstoryConfig,
  getMixpanelConfig,
  getSegmentConfig,
  isAnalyticsEnabled,
  isCustomEventsTrackingEnabled
} from '../shared/utils/config';
import { Tracker, TrackerUserProperties, TrackingEvent } from './trackers/tracker';
import { TrackerConfig } from './interfaces/tracker-config';
import { mixpanelService } from './trackers/mixpanel.service';
import { fullstoryService } from './trackers/fullstory.service';
import { segmentService } from './trackers/segment.service';
import { NetworkRequestOptions } from '../request/interfaces/request-options';
import { courierService } from '../request/services/courier.service';

class TrackingService {
  registry: { service: Tracker; config: TrackerConfig }[] = [
    {
      service: mixpanelService,
      config: getMixpanelConfig()
    },
    {
      service: fullstoryService,
      config: getFullstoryConfig()
    },
    {
      service: segmentService,
      config: getSegmentConfig()
    }
  ];

  start() {
    this.registry.forEach(({ service, config }) => {
      if (isAnalyticsEnabled(config)) {
        service.start();
      }
    });
  }

  stop() {
    this.registry.forEach(({ service, config }) => {
      if (isAnalyticsEnabled(config)) {
        service.stop();
      }
    });
  }

  onUserChange(user: User) {
    this.trackDNTSettings(user);
    this.refresh();
  }

  refresh() {
    this.registry.forEach(({ service, config }) => {
      if (isAnalyticsEnabled(config)) {
        service.start();
      } else {
        service.stop();
      }
    });
  }

  reset() {
    this.registry.forEach(({ service, config }) => {
      if (isAnalyticsEnabled(config)) {
        service.reset();
      }
    });
  }

  setIdentity(user: User) {
    this.registry.forEach(({ service, config }) => {
      if (isAnalyticsEnabled(config)) {
        service.setIdentity(user);
      }
    });
  }

  updateUserProperties(user: User, data: TrackerUserProperties) {
    this.registry.forEach(({ service, config }) => {
      if (isAnalyticsEnabled(config)) {
        service.updateUserProperties(user, data);
      }
    });
  }

  track(event: TrackingEvent) {
    this.registry.forEach(({ service, config }) => {
      if (isCustomEventsTrackingEnabled(config)) {
        service.track(event);
      }
    });
  }

  pageTrack(path: string) {
    this.registry.forEach(({ service, config }) => {
      if (isCustomEventsTrackingEnabled(config)) {
        service.pageTrack(path);
      }
    });
  }

  trackDNTSettings(user: User) {
    const params = {
      event: 'do not track settings',
      properties: {
        email: user.email,
        doNotTrack: navigator.doNotTrack || 'unspecified',
        deploymentEnv: getDeploymentEnv()
      }
    };

    const options: NetworkRequestOptions = {
      networkOptions: {
        headers: { Anonymous: 'True' }
      }
    };

    courierService.post('https://asia-webhook.hevodata.com/t/ryj1atyfhb', params, options).then(
      () => {},
      () => {}
    );
  }
}

export const trackingService = new TrackingService();
